var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.9 16.5",
    enableBackground: "new 0 0 14.9 16.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4ba84f",
    d: "M14.3,5.5L8.4,0.4c-0.6-0.6-1.6-0.6-2.1,0L0.6,5.5C0.2,5.9,0,6.4,0,6.8v8.1c0,0.7,0.6,1.4,1.5,1.4H6l-0.1-5 c0-0.1,0.1-0.1,0.1-0.1h2.7c0.1,0,0.2,0.1,0.2,0.2v5h4.5c0.7,0,1.5-0.6,1.5-1.5V6.8C14.9,6.4,14.7,5.9,14.3,5.5z M8.7,9.9H6L6,9.9 c-0.8,0.3-1.3,0.9-1.3,1.5v3.8H1.5c-0.1,0-0.2-0.1-0.2-0.2V6.8c0-0.1,0.1-0.3,0.2-0.4l5.8-5.2c0.1-0.1,0.2-0.1,0.4,0l5.8,5.1 c0.2,0.1,0.2,0.3,0.2,0.4v8.1c0,0.1-0.1,0.2-0.1,0.2h-3.4v-3.7C10.1,10.6,9.5,9.9,8.7,9.9z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.1b7a316c0db68b7cf003d99cd126f239.svg";
export { ForwardRef as ReactComponent };